import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { IResponse } from '../../common/interfaces/response.interface';
import { INotification, INotificationParams } from '../../common/interfaces/notification.interface';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    http = inject(HttpClient);
    baseUrl = environment.baseUrl;

    setNotification(payload: { isNotificationEnabled?: boolean; isChatNotificationEnabled?: boolean }): Observable<IResponse<null>> {
        return this.http.post<IResponse<null>>(`${this.baseUrl}/users/updateNotificationSettings`, payload);
    }

    getNotificationList(param: INotificationParams): Observable<IResponse<INotification[]>> {
        let params = new HttpParams();
        params = params.append('page', param.page);
        params = params.append('limit', param.limit);
        if (param.sortBy) {
            params = params.append('sortBy', param.sortBy);
        }
        if (param.readStatus) {
            params = params.append('readStatus', param.readStatus);
        }
        return this.http.get<IResponse<INotification[]>>(`${this.baseUrl}/notifications/list`, {
            params
        });
    }

    statusUpdate(payload: { id?: string } | null): Observable<IResponse<null>> {
        return this.http.post<IResponse<null>>(`${this.baseUrl}/notifications/updateStatus`, payload);
    }

    getUnreadStatus(): Observable<IResponse<{ hasUnreadNotifications: boolean }>> {
        return this.http.get<IResponse<{ hasUnreadNotifications: boolean }>>(`${this.baseUrl}/notifications/unread-status`);
    }
}
